import type { Category, Pagination } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'categories';

export function getCategories(query?: Category.SearchQuery) {
    return api.get<Pagination<Category>>(rootPath, query);
}

export function getCategory(id: number) {
    return api.get<Category.DetailsResponse>(`${rootPath}/${id}`, undefined);
}

export function postCategory(data: Category.CreateRequest) {
    return api.post<Category>(rootPath, data);
}

export function putCategory(id: number, data: Category.UpdateRequest) {
    return api.put<Category>(`${rootPath}/${id}`, data);
}

export function deleteCategory({ id }: Category.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
